<template>
  <div id="item-page-w" v-observe-visibility="itemVisibilityChange">
    <div id="item-content-w">
      <div class="text-part">
        <div slot="header" class="item-head">
          <div style="display: inline-block; width: calc(100% - 70px); text-transform: capitalize">
            <span>{{currentItem.index >= 10 ? currentItem.index : '0'+currentItem.index}} {{currentItem.name}}</span>
            <half-circle-spinner
              v-show="currentItem.refreshing"
              :animation-duration="500"
              :size="17"
              color="#f57c00"
              style="margin-left: 14px; display: inline-block;"
            />
          </div>
          <div
            style="display: inline-block; width: 50px; line-height: 27px; float: right"
            v-if="canEdit"
          >
            <el-button style="padding: 3px 0; " type="text" @click="editItem()">Edit</el-button>
          </div>
        </div>
        <div class="image-text">
          <el-alert :title="openEditorError" type="error" v-if="openEditorError"></el-alert>

          <div v-for="question in currentItemStr" :key="question.name">
            <div class="question-div">
              <div class="question-name">{{ question.name }}:</div>
              <div class="question-value">{{ question.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="image-part">
        <div class="add-price" v-if="canViewPrice">
          <div slot="header" class="item-head">
            <div
              style="display: inline-block; width: calc(100% - 70px); text-transform: capitalize"
            >
              <span>Price</span>
            </div>
            <div
              style="display: inline-block; width: 50px; line-height: 27px; float: right"
              v-if="canEditPrice && !editPrice"
            >
              <el-button style="padding: 3px 0; " type="text" @click="editItemPrice()">Edit</el-button>
            </div>
          </div>
          <div class="image-text" v-if="!editPrice">
            <div>
              <div class="question-div">
                <div class="question-name">List</div>
                <div class="question-value">${{ computedPrice.list }}</div>
              </div>
              <div class="question-div">
                <div class="question-name">Surcharge</div>
                <div class="question-value">${{ computedPrice.surcharge }}</div>
              </div>
              <div class="question-div">
                <div class="question-name">Cost Factor</div>
                <div class="question-value">{{ computedPrice.costFactor }}</div>
              </div>
              <div class="question-div">
                <div class="question-name">Discount</div>
                <div class="question-value">${{ computedPrice.discount }}</div>
              </div>
            </div>
            <div class="question-div">
              <div class="question-name">Cost</div>
              <div class="question-value">${{ computedPrice.cost }}</div>
            </div>
            <div class="question-div">
              <div class="question-name">Extended</div>
              <div class="question-value">${{ computedPrice.extended }}</div>
            </div>
          </div>
          <div class="image-text" v-else>
            <div>
              <div class="question-div no-flex">
                <div class="question-name">List</div>
                <el-input
                  class="price-input"
                  placeholder="Enter list"
                  v-model="priceInfoCopy.list"
                  clearable
                  @blur="validatePriceInput"
                  @focus="resetPriceVlidate"
                ></el-input>
                <div class="invalid-price" v-show="!priveInputValid.list">Number input is invalid!</div>
              </div>
              <div class="question-div no-flex">
                <div class="question-name">Surcharge</div>
                <el-input
                  class="price-input"
                  placeholder="Enter surcharge"
                  v-model="priceInfoCopy.surcharge"
                  clearable
                  @blur="validatePriceInput"
                  @focus="resetPriceVlidate"
                ></el-input>
                <div
                  class="invalid-price"
                  v-show="!priveInputValid.surcharge"
                >Number input is invalid!</div>
              </div>
              <div class="question-div no-flex">
                <div class="question-name">Cost Factor</div>
                <el-input
                  class="price-input"
                  placeholder="Enter cost factor"
                  v-model="priceInfoCopy.costFactor"
                  clearable
                  @blur="validatePriceInput"
                  @focus="resetPriceVlidate"
                ></el-input>
                <div
                  class="invalid-price"
                  v-show="!priveInputValid.costFactor"
                >Number input is invalid!</div>
              </div>
              <div class="question-div no-flex">
                <div class="question-name">Disc Amount</div>
                <el-input
                  class="price-input"
                  placeholder="Enter disc amount"
                  v-model="priceInfoCopy.discount"
                  clearable
                  @blur="validatePriceInput"
                  @focus="resetPriceVlidate"
                ></el-input>
                <div
                  class="invalid-price"
                  v-show="!priveInputValid.discount"
                >Number input is invalid!</div>
              </div>
            </div>
            <div>
              <el-button type="primary" round @click="savePrice()">Save</el-button>
              <el-button type="info" plain round @click="cancelPrice()">Cancel</el-button>
            </div>
          </div>
        </div>
        <vue-gallery :images="currentItem.images" :index="openIndex" @close="openIndex = null"></vue-gallery>
        <el-carousel
          v-if="currentItem.images.length !== 0"
          height="400px"
          :interval="5000"
          arrow="always"
          style="margin-top: 20px;"
        >
          <el-carousel-item v-for="(image,index) in currentItem.images" :key="index">
            <div
              class="image-light-box"
              @click="openIndex = index"
              :style="{ backgroundImage: 'url(' + image + ')' }"
            ></div>
          </el-carousel-item>
        </el-carousel>
        <div v-else style="margin-top: 20px; font-weight: bold">No images</div>
      </div>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
const intRegex = /^\d+$/
const floatRegex = /^\d+\.\d+$/

export default {
  name: 'ItemPage',
  components: { HalfCircleSpinner },
  props: {
    currentItem: Object
  },
  data () {
    return {
      openEditorError: '',
      itemCardHidden: null,
      openIndex: null,
      editPrice: false,
      priceInfoCopy: null,
      priveInputValid: {
        list: true,
        surcharge: true,
        costFactor: true,
        discount: true
      }
    }
  },
  computed: {
    computedPrice: function () {
      let list = parseFloat(this.currentItem.priceInfo.list || '0')
      let surcharge = parseFloat(this.currentItem.priceInfo.surcharge || '0')
      let costFactor = parseFloat(this.currentItem.priceInfo.costFactor || '1')
      let discount = parseFloat(this.currentItem.priceInfo.discount || '0')
      let cost = (list + surcharge) * costFactor - discount
      let extended = cost * this.itemQuantity

      return {
        list: list.toFixed(2),
        surcharge: surcharge.toFixed(2),
        costFactor: costFactor,
        discount: discount.toFixed(2),
        cost: cost.toFixed(2),
        extended: extended.toFixed(2)
      }
    },
    itemQuantity: function () {
      let quantityQuestion = this.currentItem.questions.find(
        question => question.name === 'Quantity'
      )
      if (quantityQuestion) {
        return parseInt(quantityQuestion.value[0])
      } else {
        return 1
      }
    },
    canEdit: function () {
      if (
        this.$store.state.currentProject.status !== 'MEASUREMENT' &&
        !this.$store.getters.currentUserInfo.permits.ITEM_FORCE_EDIT
      ) {
        return false
      }
      return true
    },
    canEditPrice: function () {
      return this.$store.getters.currentUserInfo.permits.ITEM_PRICE_VIEW
    },
    canViewPrice: function () {
      return this.$store.getters.currentUserInfo.permits.ITEM_PRICE_EDIT
    },
    currentItemStr: function () {
      if (!this.currentItem) {
        return []
      }
      let currentItemStr = []
      let questions = this.currentItem.questions

      for (var i = 0; i < questions.length; i++) {
        let value = null
        if (typeof questions[i].value !== 'string') {
          if (questions[i].value[0] === true) {
            value = 'Yes - ' + questions[i].value.slice(1).join(' - ')
          } else if (questions[i].value[0] === false) {
            value = 'No - ' + questions[i].value.slice(1).join(' - ')
          } else {
            value = questions[i].value.join(' - ')
          }
        } else {
          value = questions[i].value
        }
        let id = questions[i].id
        let name = questions[i].name
        // console.log(name);

        currentItemStr.push({
          id: id,
          name: name,
          value: value
        })
      }
      // console.log(this.currentItem.questions);
      return currentItemStr
    }
  },
  methods: {
    validatePriceInput: function () {
      console.log('Vlidate price input')
      let list = this.priceInfoCopy.list === '' || intRegex.test(this.priceInfoCopy.list) || floatRegex.test(this.priceInfoCopy.list)
      let surcharge = this.priceInfoCopy.surcharge === '' || intRegex.test(this.priceInfoCopy.surcharge) || floatRegex.test(this.priceInfoCopy.surcharge)
      let costFactor = this.priceInfoCopy.costFactor === '' || intRegex.test(this.priceInfoCopy.costFactor) || floatRegex.test(this.priceInfoCopy.costFactor)
      let discount = this.priceInfoCopy.discount === '' || intRegex.test(this.priceInfoCopy.discount) || floatRegex.test(this.priceInfoCopy.discount)
      let result = {
        list, surcharge, costFactor, discount
      }
      this.priveInputValid = result
    },
    resetPriceVlidate: function () {
      this.priveInputValid = {
        list: true,
        surcharge: true,
        costFactor: true,
        discount: true
      }
    },
    editItem: async function () {
      // console.log("click edit button");
      let activeEditResult = await this.$store.dispatch(
        'editItem',
        this.currentItem.id
      )
      if (activeEditResult.success) {
        // DO NOTHING, WAIT FOR EDITOR
        window.scrollTo(0, 0)
      } else {
        this.openEditorError = activeEditResult.error
      }
    },
    editItemPrice: function () {
      this.priceInfoCopy = {
        list: this.currentItem.priceInfo.list,
        surcharge: this.currentItem.priceInfo.surcharge,
        costFactor: this.currentItem.priceInfo.costFactor,
        discount: this.currentItem.priceInfo.discount
      }
      this.editPrice = true
    },
    itemVisibilityChange: function (isVisible, entry) {
      if (isVisible && this.itemCardHidden) {
        // on page init, itemCardHidden === null, so no refresh is called
        this.itemCardHidden = false
        this.$emit('refresh-item')
      } else {
        this.itemCardHidden = true
      }
    },
    toInputPrice: function (index, value) {
      let currentItemPriceStr = this.currentItemPriceStr
      currentItemPriceStr[index].value = value
    },
    savePrice: async function () {
      for (let prop in this.priceInputValid) {
        if (!this.priceInputValid[prop]) {
          return
        }
      }
      let currentItemCopy = JSON.parse(JSON.stringify(this.currentItem))
      currentItemCopy.priceInfo = JSON.parse(JSON.stringify(this.priceInfoCopy))
      let itemToSave = JSON.parse(JSON.stringify(currentItemCopy))
      let saveRequest = {
        itemToSave: itemToSave,
        nextItem: null
      }
      let saveResult = await this.$store.dispatch('saveItemChange', saveRequest)
      if (saveResult.success) {
        this.$message.success('Saved!')
        window.scrollTo(0, 0)
        this.editPrice = false
      } else {
        this.$message.error('Network error, please try again')
      }
    },
    cancelPrice: function () {
      this.priceInfoCopy = this.currentItem.priceInfo
      this.editPrice = false
    }
  }
}
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.image-light-box {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  cursor: zoom-in;
}

.image-text {
  margin-top: 24px;
}

.item-page-w {
  font-size: 16px;
  font-weight: bold;
}

#item-content-w {
  display: flex;
}

.text-part {
  width: 50%;
  box-sizing: border-box;
  padding: 0 20px 20px 20px;
}

.image-part {
  width: 50%;
  box-sizing: border-box;
  padding: 0 20px;
}

.item-head {
  font-size: 18px;
  font-weight: bold;
  line-height: 27px;
  border-bottom: solid 1px #f0f0f0;
  box-sizing: border-box;
  padding: 8px 0;
}

.item-detail-text {
  box-sizing: border-box;
  padding: 16px 0 8px 0;
}

.question-div {
  display: flex;
  margin-bottom: 12px;
  padding-bottom: 12px;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.no-flex {
  display: block;
}

.question-name {
  box-sizing: border-box;
  padding-top: 0px;
  padding-bottom: 12px;
  border-top: 1px none #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 15px;
  line-height: 25px;
  color: #969696;
  font-weight: bold;
}

.question-value {
  margin-left: 20px;
  box-sizing: border-box;
  padding-bottom: 12px;
  line-height: 27px;
  font-size: 18px;
  color: #333;
}

@media screen and (max-width: 991px) {
  #item-content-w {
    display: block;
  }

  .text-part {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 20px 0 20px;
  }

  .image-part {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px 20px 20px;
  }

  .image-text {
    margin-top: 20px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 500px) {
  .text-part {
    width: 100%;
    box-sizing: border-box;
    padding: 4px 4px 0 4px;
  }

  .image-part {
    width: 100%;
    box-sizing: border-box;
    padding: 0 4px 4px 4px;
  }

  .image-text {
    margin-top: 20px;
    box-sizing: border-box;
  }

  .question-value {
    margin-left: 16px;
    box-sizing: border-box;
    padding-bottom: 12px;
    line-height: 21px;
    font-size: 14px;
    color: #333;
  }
}
</style>
